import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import '../static/css/Home.css';
import goblet_icon from '../static/other/goblet.png';
import magnifier_icon from '../static/other/magnifier.png';
import lamp_icon from '../static/other/lamp.png';
import home_art from '../static/other/home_art.webp';

import sort_me_telegram from '../static/other/sort-me-telegram.jpg';
import sort_me_chat_telegram from '../static/other/sort-me-chat-telegram.jpg';

import GlobalContext from '../global';

import LoginContainer from '../components/login';

const titles = ["Лучшее место, чтобы учиться спортивному программированию", "Новый способ учиться спортивному программированию",];

// The live 3D scene is heavy (WebGL + ~600 KB of JS), so it runs only on mouse-driven desktops without reduced motion.
// Everything else (phones, tablets, touch laptops) gets a static render of the same scene.
function canUseLiveArt() {
  return typeof window.matchMedia === "function"
    && window.matchMedia("(min-width: 1100px) and (hover: hover) and (pointer: fine)").matches
    && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function HomeArt() {
  const [live] = useState(canUseLiveArt);
  const ref = useRef(null);

  useEffect(() => {
    if (!live) return;
    let detach = null, unmounted = false;
    import('../components/3dhomepage').then(module => {
      if (!unmounted) detach = module.default(ref.current);
    });
    return () => {
      unmounted = true;
      if (detach) detach();
    };
  }, [live]);

  return <div ref={ref} className={live ? "home-art live" : "home-art"} aria-hidden="true">
    {!live && <img src={home_art} alt="" width="564" height="566" decoding="async" />}
  </div>;
}

function TelegramIcon() {
  return <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M1.14114 6.64537C4.51143 5.23178 6.75882 4.29986 7.88331 3.8496C11.094 2.56402 11.7611 2.3407 12.1959 2.33333C12.2916 2.33171 12.5054 2.35453 12.6439 2.46273C12.7609 2.55409 12.7931 2.67751 12.8085 2.76413C12.8239 2.85075 12.843 3.04808 12.8278 3.20227C12.6538 4.96213 11.901 9.23284 11.518 11.2039C11.3559 12.0379 11.0345 12.2165 10.7256 12.2438C10.0542 12.3033 9.5467 11.9178 8.89644 11.5075C7.87891 10.8654 7.5049 10.6924 6.51721 10.0659C5.37577 9.34173 5.99852 8.96271 6.64902 8.31228C6.81926 8.14206 9.79838 5.49041 9.85563 5.25543C9.86279 5.22605 9.76479 4.93222 9.69719 4.87438C9.62959 4.81654 9.52982 4.83632 9.45782 4.85205C9.35577 4.87435 7.73026 5.90866 4.58129 7.95497C4.11989 8.25998 3.70197 8.40859 3.32753 8.4008C2.91474 8.39221 2.1207 8.17611 1.53041 7.99139C0.806392 7.76483 0.539133 7.65813 0.589241 7.27335C0.615339 7.07293 0.799306 6.8636 1.14114 6.64537Z" />
  </svg>;
}

class Home extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);
    this.title = titles[Math.floor(Math.random() * titles.length)];
  }

  componentDidMount() {
    document.title = "Sort Me - Лучшее место, чтобы учиться спортивному программированию";
  }

  render() {
    const login = this.context.login;
    if (login === undefined) {
      return <div className="main-content" />;
    }

    return (
      <div className="main-content home">
        {login === null ? <section className="home-hero">
          <HomeArt />
          <div className="home-hero-copy">
            <h1 className="header">{this.title}</h1>
            <p>Sort Me - быстрая, доступная и стабильная платформа для олимпиадного программирования.</p>
            <p>Повторяйте и изучайте алгоритмы, тренируйтесь на огромной базе задач и соревнуйтесь с другими пользователями!</p>
          </div>
          <LoginContainer id="top-login" title={"Войти или зарегистрироваться"} />
        </section> : <h1 className="header">Привет, {login}!</h1>}

        <div id="top-headers-table">
          <Link to="/contest" className="home-feature">
            <img src={goblet_icon} alt="" width="80" height="80" />
            <h3 className="home-feature-contest">Соревнования</h3>
            <p>Проверьте свои навыки на архиве реальных олимпиад</p>
          </Link>
          <Link to="/tasks" className="home-feature">
            <img src={magnifier_icon} alt="" width="80" height="80" />
            <h3 className="home-feature-tasks">Задачи</h3>
            <p>Огромная база задач на любую тему и любой уровень</p>
          </Link>
          <div className="home-feature disabled">
            <img src={lamp_icon} alt="" width="80" height="80" />
            <h3>Алгоритмы</h3>
            <p>Скоро! Подпишитесь на <a href="https://t.me/sort_me" target="_blank" rel="noreferrer">телеграм-канал</a> и не пропустите релиз</p>
          </div>
        </div>

        <section className="home-telegram-proposal">
          <h2>Присоединяйтесь к сообществу Sort Me</h2>
          <a href="https://t.me/sort_me" target="_blank" rel="noreferrer" className="home-telegram-block">
            <img alt="" src={sort_me_telegram} width="52" height="52" />
            <div>
              <h3>Sort Me</h3>
              <span><TelegramIcon />t.me/sort_me</span>
            </div>
          </a>
          <a href="https://t.me/sort_me_chat" target="_blank" rel="noreferrer" className="home-telegram-block">
            <img alt="" src={sort_me_chat_telegram} width="52" height="52" />
            <div>
              <h3>Sort Me Chat</h3>
              <span><TelegramIcon />t.me/sort_me_chat</span>
            </div>
          </a>
        </section>
      </div>
    );
  }
}

export default Home;
